import { Category } from "@/types";
import { atom } from "jotai";

const categoriesAtom = atom<Category[]>([])

export default categoriesAtom
